const strings = {
  'history/inProgress/text': {
    en: 'In Progress',
    fr: 'En cours',
  },
  'history/noPicks/title': {
    en: 'No Player Selected',
    fr: 'Vous n’avez pas choisi de joueur',
  },
  'history/noPicks/text': {
    en: 'Sorry, you didn’t submit picks on this date.',
    fr: 'Désolé, vous n’avez pas soumis de choix à cette date.',
  },
  'history/resultsPending/text': {
    en: '<span>Results are pending. Please check back later.</span>',
    fr: '<span>Les résultats ne sont pas encore disponibles. Veuillez revenir plus tard.</span>',
  },
  'history/noPicksAggregated/text': {
    en: (days) => {
      return `You haven't selected picks for the past ${days} days.`;
    },
    fr: (days) => {
      return `Vous n'avez pas choisi de joueurs pour les derniers ${days} jours.`;
    },
  },
  'history/notification/loyalty3/title': {
    en: 'Updates To Tim’s Rewards',
    fr: 'Changements à FidéliTim<sup>MC</sup>',
  },
  'history/notification/loyalty3/text': {
    en: `<span>With the new updates to our Tim's Rewards Program, the number of points you earn for each pick has changed! </span><a style="color: #FFFF;" target="_parent" href="https://www.timhortons.ca/newtimsrewards">Learn More</a>`,
    fr: '<span>Dans le cadre des changements au programme FidéliTim<sup>MC</sup>, vous obtenez un nombre de points différent pour chaque choix gagnant! </span><a style="color: #FFFF;" target="_parent" href="https://www.timhortons.ca/nouveaufidelitim">En savoir plus</a>',
  },

  'history/error/gameResults/text': {
    en: 'We’re having trouble displaying recent game results. Please check back later.',
    fr: 'Nous éprouvons des difficultés à afficher les résultats des dernières parties. Veuillez revenir plus tard.',
  },

  'history/empty/title': {
    en: `It looks like you haven't played yet. <br/> Please make some picks to </br> get started!`,
    fr: `On dirait que vous n’avez pas encore joué. <br/> Faites vos choix </br> pour commencer!`,
  },
};

export default strings;
